export const OcrV2BlockDocumentationMarkdown = `
# OCR

## What does this block do?

Extracts text from documents and images using a Vision Language Model (Anthropic Claude Opus 4.6), benchmarked for highest accuracy on checkboxes, radio buttons, and handwritten marks.

The block works out of the box with no configuration beyond the file reference. Prompt customization is available for advanced use cases.

Supported File Types
* Documents: PDF, TIFF
* Images: PNG, JPEG/JPG, GIF, BMP


## When to use it?

Use this block whenever you need to convert a document or image into text for downstream processing. Common use cases:

* Fax transcription (inbound referrals, orders)
* Document categorization pipelines
* Data extraction from forms with checkboxes and handwriting

Chain with other blocks like:
* FilterList (organization)
* LLM (structured extraction, summarization)
* Script (parsing)
* PatientDataStore (storage)

## How to use

### Step 1: Add the file

The block accepts files through file references:
* Format: \`{type}:{identifier}\`
* Example: \`externalDocumentPacket:<uuid>\`

### Step 2: Run it

For most use cases, the default configuration is all you need. The block uses Anthropic Claude Opus 4.6 with a prompt optimized for checkboxes, radio buttons, and document structure. All pre-processing (denoising, page chunking, edge cleanup) is handled automatically.

### Step 3: Advanced configuration (optional)

**Prompt** — Pre-populated with instructions for checkboxes and document structure. Enable "Custom prompt" to customize for domain-specific needs (e.g., change check mark symbols, add extraction rules). Toggling off resets to the default prompt.

**Traditional OCR** — Select "Traditional OCR" from the processing method dropdown if you need bounding box coordinates or detail-level metadata. This uses Google Vision API with configurable detail level and bounding box options.

## Output

Returns an object containing:
* text: The extracted text content
* metadata: An object with page-level details
  * totalPages: The number of pages processed
  * pageLengths: Array of character counts per page
  * pageDelimiter: The delimiter string between pages (if multi-page)

When using Traditional OCR with metadata enabled:
* Page dimensions, confidence scores, detected languages
* Bounding box coordinates (when enabled)

## Error Handling
Block execution can fail for any of the following reasons:
* Invalid file reference
* Missing file
* Unsupported file type
`;
